import { isFieldErrorResponse, useApiTradeV1SupplySignalsCreate } from 'api';
import { useNotification } from 'features';
import { UseFormReturn } from 'form';

import {
  SupplySignalFormInputValues,
  SupplySignalFormValues,
} from '../../schema/SupplySignalSchema/SupplySignalSchema';

export const useCreateSupplySignal = (
  form: UseFormReturn<SupplySignalFormInputValues, unknown, SupplySignalFormValues>
) => {
  const { setError } = form;
  const { open } = useNotification();
  return useApiTradeV1SupplySignalsCreate({
    mutation: {
      onError(error) {
        if (isFieldErrorResponse(error)) {
          Object.keys(error.response?.data).forEach((field) => {
            setError(field as keyof SupplySignalFormValues, { message: error.response.data[field] });
          });
        }
        if (error?.response?.data.non_field_errors) {
          open({
            description: error.response.data.non_field_errors.toString(),
            message: 'Error creating supply signal',
            type: 'error',
          });
        }
      },
      async onSuccess(supply_signal) {
        open({
          description: `Supply Signal created with ID: ${supply_signal.id}`,
          message: 'Supply Signal created',
          type: 'success',
        });
        form.reset();
      },
    },
  });
};
